import { useSelector } from 'react-redux';

import { useGetCurrentUser } from '@front/auth/src/authentication-context';

import {
  getModifiedBooking,
  getIsMembershipRequested,
  getMode,
} from '@front/common/src/ducks/customer/basket-selectors';
import { BasketMode } from '@front/common/src/types/commons';
import { Booking } from '@front/common/src/types/customer';

import { hasMembership } from '../../utils/membership';

const modificationModes: BasketMode[] = ['modifyPrestations', 'modifyAppointment', 'modification'];

const useHasOrWantsMembership = () => {
  const user = useGetCurrentUser();
  const isMembershipRequested: boolean | undefined = useSelector(getIsMembershipRequested);
  const modifiedBooking: Booking | undefined = useSelector(getModifiedBooking);
  const mode: BasketMode | null = useSelector(getMode);

  // In modification mode, we show membership prices if the booking has been created during
  // active or requested membership.
  // Like this customers have correct prices when modifying a membership booking, even if their
  // user membership status changed.
  if (!!mode && modificationModes.includes(mode) && !!modifiedBooking) {
    return !!modifiedBooking.has_membership;
  }

  // During creation user is either already member or the paywall got validated
  return hasMembership(user) || !!isMembershipRequested;
};

export default useHasOrWantsMembership;
